// extracted by mini-css-extract-plugin
export default {"content":"FormAgreement_content__HRZoD","notice":"FormAgreement_notice__HO+7p","down":"FormAgreement_down__hKYi3"};